export function SinDatosTitle() {
    return (
        <div className="grid items-center h-[200px]">
            <p className="font-semibold text-4xl text-center">Sin Datos</p>
        </div>
    );
}